<script>
export default {
  methods: {
    generateBannerObject(texts, index = 0, alertDefinitions = []) {
      if (texts[index] && !this.connectivityCheck[index]) {
        const bannerObject = {
          color: index ? 'warning' : 'error',
          isActive: true,
          icon: 'mdi-wifi-strength-off',
          text: texts[index] + '.',
          type: 'alert',
          dismissible: true,
          multiLine: texts[index].includes(';'),
        }
        alertDefinitions.push(bannerObject)
      }
      if (index < 1)
        return this.generateBannerObject(texts, ++index, alertDefinitions)
      return alertDefinitions
    },
    generateTextForBanner() {
      let bannerTexts = ['', '']
      const commonText =
        'Ascentia has not received full flight data from the entire'
      this.connectivityAirlines.forEach(airline => {
        const alertText = `${commonText} ${airline.airline} fleet for ${airline.daysSince} days`
        const index = airline.phm ? 0 : 1
        if (bannerTexts[index].length > 0)
          bannerTexts[index] = bannerTexts[index] + '; '
        bannerTexts[index] = bannerTexts[index] + alertText
      })
      bannerTexts = bannerTexts.map(text =>
        text.length ? `Connectivity Warning: ${text}` : text,
      )
      return bannerTexts
    },
  },
}
</script>
